(() => {
  const setup = (productInfo) => {
    const sticky = productInfo.querySelector('[data-allbirds-sticky]');
    const info = productInfo.querySelector('.product__info-container');
    const mainButton = productInfo.querySelector('.product-form__submit');
    const stickyButton = sticky?.querySelector('[data-allbirds-sticky-submit]');
    const stickyPrice = sticky?.querySelector('[data-allbirds-sticky-price]');
    const mainPrice = productInfo.querySelector('[id^="price-"]');
    if (!sticky || !info || !mainButton || !stickyButton) return;

    sticky.hidden = false;
    const sync = () => {
      stickyButton.textContent = mainButton.querySelector('span')?.textContent?.trim() || mainButton.textContent.trim();
      stickyButton.disabled = mainButton.disabled;
      if (stickyPrice && mainPrice) stickyPrice.textContent = mainPrice.textContent.replace(/\s+/g, ' ').trim();
    };

    sync();
    new MutationObserver(sync).observe(mainButton, { attributes: true, childList: true, subtree: true });
    if (mainPrice) new MutationObserver(sync).observe(mainPrice, { childList: true, subtree: true });

    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { threshold: 0.05 });
    observer.observe(info);

    stickyButton.addEventListener('click', () => {
      if (mainButton.disabled) {
        info.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainButton.click();
    });
  };

  document.querySelectorAll('product-info').forEach(setup);
})();
